import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  class: "page-loader page-loader-logo",
  style: {"display":"block","padding-top":"366px"}
}
const _hoisted_3 = { class: "container text-center itens-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Logo",
  src: "/media/logos/hc.svg",
  width: "500"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { class: "" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1)
const _hoisted_10 = { class: "text-muted fs-3 fw-bold mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("span", _hoisted_10, "   Hacking " + _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.user_progress.in_progress`)) + "...", 1)
        ])
      ])
    ])
  ]))
}